// extracted by css-extract-rspack-plugin
export default {"tabsWithActions":"Tabs__tabsWithActions--muPwd l-wrap-xl","tabs":"Tabs__tabs--ZsTCO","actions":"Tabs__actions--RYTfZ"};